import React from 'react';

const NextPost = () => {
    return (
        <section className="divider-top" data-appear="fade-up">
            <div className="align-center" data-unload="zoom-in">
                <a href="portfolio-post02.html" className="infocolors-icon-link infocolors-next-post">
                    <div className="infocolors-icon-link-content">
                        <h6>Next Project</h6>
                        <h2>Cookie Dough</h2>
                    </div>
                    <div className="infocolors-icon-wrap">
                        <i className="infocolors-icon infocolors-icon-explore"></i>
                    </div>
                </a>
            </div>
        </section>
    );
};

export default NextPost;
